module.exports = __webpack_public_path__ + "img/hexa_logo_laranja.e407af88.png";